import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminFrequently_asked_questions_id = z.any()
export type TagsGetAdminFrequently_asked_questions_id = z.infer<typeof tagsGetAdminFrequently_asked_questions_id>

export const paramsGetAdminFrequently_asked_questions_id = z.object({ "id": z.string() })
export type ParamsGetAdminFrequently_asked_questions_id = z.infer<typeof paramsGetAdminFrequently_asked_questions_id>

export const responseGetAdminFrequently_asked_questions_id = z.object({ "payload": z.object({ "id": z.string(), "question": z.string(), "answer": z.string(), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]), "userId": z.string(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminFrequently_asked_questions_id = z.infer<typeof responseGetAdminFrequently_asked_questions_id>

interface IGetAdminFrequently_asked_questions_id extends BaseMethodType {
  tags: TagsGetAdminFrequently_asked_questions_id,
  params: ParamsGetAdminFrequently_asked_questions_id,
  response: ResponseGetAdminFrequently_asked_questions_id
}
export const tagsPatchAdminFrequently_asked_questions_id = z.any()
export type TagsPatchAdminFrequently_asked_questions_id = z.infer<typeof tagsPatchAdminFrequently_asked_questions_id>

export const paramsPatchAdminFrequently_asked_questions_id = z.object({ "id": z.string() })
export type ParamsPatchAdminFrequently_asked_questions_id = z.infer<typeof paramsPatchAdminFrequently_asked_questions_id>

export const bodyPatchAdminFrequently_asked_questions_id = z.object({ "question": z.string().min(1).max(500).optional(), "answer": z.string().min(1).max(2000).optional(), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]).optional() })
export type BodyPatchAdminFrequently_asked_questions_id = z.infer<typeof bodyPatchAdminFrequently_asked_questions_id>

export const responsePatchAdminFrequently_asked_questions_id = z.object({ "payload": z.object({ "id": z.string(), "question": z.string(), "answer": z.string(), "visibility": z.union([z.literal("PUBLIC"), z.literal("HIDDEN")]), "userId": z.string(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminFrequently_asked_questions_id = z.infer<typeof responsePatchAdminFrequently_asked_questions_id>

interface IPatchAdminFrequently_asked_questions_id extends BaseMethodType {
  tags: TagsPatchAdminFrequently_asked_questions_id,
  params: ParamsPatchAdminFrequently_asked_questions_id,
  body: BodyPatchAdminFrequently_asked_questions_id,
  response: ResponsePatchAdminFrequently_asked_questions_id
}
export const tagsDeleteAdminFrequently_asked_questions_id = z.any()
export type TagsDeleteAdminFrequently_asked_questions_id = z.infer<typeof tagsDeleteAdminFrequently_asked_questions_id>

export const paramsDeleteAdminFrequently_asked_questions_id = z.object({ "id": z.string() })
export type ParamsDeleteAdminFrequently_asked_questions_id = z.infer<typeof paramsDeleteAdminFrequently_asked_questions_id>

export const responseDeleteAdminFrequently_asked_questions_id = z.any()
export type ResponseDeleteAdminFrequently_asked_questions_id = z.infer<typeof responseDeleteAdminFrequently_asked_questions_id>

interface IDeleteAdminFrequently_asked_questions_id extends BaseMethodType {
  tags: TagsDeleteAdminFrequently_asked_questions_id,
  params: ParamsDeleteAdminFrequently_asked_questions_id,
  response: ResponseDeleteAdminFrequently_asked_questions_id
}
export const URL = '/admin/frequently-asked-questions/:id'
export const validation = {
  get: {
    tags: tagsGetAdminFrequently_asked_questions_id,
    params: paramsGetAdminFrequently_asked_questions_id,
    response: responseGetAdminFrequently_asked_questions_id
  },
  patch: {
    tags: tagsPatchAdminFrequently_asked_questions_id,
    params: paramsPatchAdminFrequently_asked_questions_id,
    body: bodyPatchAdminFrequently_asked_questions_id,
    response: responsePatchAdminFrequently_asked_questions_id
  },
  delete: {
    tags: tagsDeleteAdminFrequently_asked_questions_id,
    params: paramsDeleteAdminFrequently_asked_questions_id,
    response: responseDeleteAdminFrequently_asked_questions_id
  }
}
export interface AdminFrequently_asked_questions_id extends BaseRouteType {
  get: IGetAdminFrequently_asked_questions_id,
  patch: IPatchAdminFrequently_asked_questions_id,
  delete: IDeleteAdminFrequently_asked_questions_id
}